import { useState, useEffect } from "react";
import { RESOLUTION } from "app/constants";
import config from "app/pages/.styles/export.scss";

export const getInitResolution = () => {
	const width = window.innerWidth;
	const isDefault = width < parseFloat(config.sm);
	const isSmall = width >= parseFloat(config.sm);
	const isMedium = width >= parseFloat(config.md);
	const isLarge = width >= parseFloat(config.lg);
	let clientResolution = RESOLUTION.UNKNOWN;

	if (isDefault === false && isSmall === true && isMedium === true && isLarge === true) {
		clientResolution = RESOLUTION.XLARGE;
	} else if (isDefault === false && isSmall === true && isMedium === true && isLarge === false) {
		clientResolution = RESOLUTION.LARGE;
	} else if (isDefault === false && isSmall === true && isMedium === false && isLarge === false) {
		clientResolution = RESOLUTION.MEDIUM;
	} else if (isDefault === true && isSmall === false && isMedium === false && isLarge === false) {
		clientResolution = RESOLUTION.SMALL;
	}
	return clientResolution;
};

// -1px on each max-width excludes that boundary itself, matching getInitResolution()'s strict "<" comparisons.
const RESOLUTION_QUERIES = [
	{ query: `(max-width: calc(${config.sm} - 1px))`, resolution: RESOLUTION.SMALL },
	{
		query: `(min-width: ${config.sm}) and (max-width: calc(${config.md} - 1px))`,
		resolution: RESOLUTION.MEDIUM,
	},
	{
		query: `(min-width: ${config.md}) and (max-width: calc(${config.lg} - 1px))`,
		resolution: RESOLUTION.LARGE,
	},
	{ query: `(min-width: ${config.lg})`, resolution: RESOLUTION.XLARGE },
];

const useResponsiveState = resolution => {
	const [responsiveState, setResponsiveState] = useState(resolution);

	useEffect(() => {
		setResponsiveState(getInitResolution());

		const listeners = RESOLUTION_QUERIES.map(({ query, resolution: matchedResolution }) => {
			const mediaQuery = window.matchMedia(query);
			const handleChange = event => {
				if (event.matches) {
					setResponsiveState(matchedResolution);
				}
			};
			mediaQuery.addEventListener?.("change", handleChange);
			return { mediaQuery, handleChange };
		});

		return () => {
			listeners.forEach(({ mediaQuery, handleChange }) => {
				mediaQuery.removeEventListener?.("change", handleChange);
			});
		};
	}, []);
	return responsiveState;
};

export default useResponsiveState;
